import React from "react";
import { Modal } from "react-bootstrap";

const Privacypolicypopup = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="privacy-policy-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <h4> {props.modalData.name} </h4>
        <div className="editor-box">
          <p>
            <div
              dangerouslySetInnerHTML={{
                __html: props?.modalData?.parse_description ?? "",
              }}
            ></div>
          </p>
        </div>

        {!props.modalData.terms_of_services_read_or_accepted[0]?.is_accepted ? (
          <div className="privacy-button">
            <button
              className="primary-button delete-btn"
              onClick={() => {
                props.setModalData(false);
                props
                  .acceptTerm({
                    variables: {
                      id: props.modalData.id,
                      is_read: true,
                      is_accepted: false,
                    },
                  })
                  .then(() => {
                    props.refetch();
                  });
              }}
            >
              Not now
            </button>
            <button
              className="primary-button"
              onClick={() => {
                props.setModalData(false);
                props
                  .acceptTerm({
                    variables: {
                      id: props.modalData.id,
                      is_read: true,
                      is_accepted: true,
                    },
                  })
                  .then(() => {
                    props.refetch();
                  });
              }}
            >
              Accept
            </button>
          </div>
        ) : (
          ""
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Privacypolicypopup;
